module.exports = __webpack_public_path__ + "static/media/number circle.9db275c6.ai";